import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { CategoriesPageComponent } from '../components/categories-page/categories-page.component';
import { ErrorPageComponent } from '../components/error-page/error-page.component';
import { HomePageComponent } from '../components/home-page/home-page.component';
import { LandingPageComponent } from '../components/landing-page/landing-page.component';
import { MainComponent } from '../components/main/main.component';
import { MyBulgariPageComponent } from '../components/my-bulgari-page/my-bulgari-page.component';
import { PdfPageComponent, } from '../components/pdf-page/pdf-page.component';
import { PrivacyPolicyPageComponent } from '../components/privacy-policy-page/privacy-policy-page.component';
import { PdpService } from '../components/product-page/pdp.service';
import { ProductPageComponent } from '../components/product-page/product-page.component';
import { ProductsPageComponent } from '../components/products-page/products-page.component';
import { RulePageComponent } from '../components/rule-page/rule-page.component';
import { RuleComponent } from '../components/rule/rule.component';
import { SearchPageComponent } from '../components/search-page/search-page.component';
import { SetStorePageComponent } from '../components/set-store-page/set-store-page.component';
import { TermsAndConditionsPageComponent } from '../components/terms-and-conditions-page/terms-and-conditions-page.component';
import { Route, UrlParams } from '../models/enums/Route.enum';
import { RoleResolver } from '../resolver/role.resolver';
import { RulesResolver } from '../resolver/rules.resolver';
import { FiltersService } from '../services/filters.service';
import { HasAssociatedStoreGuard } from './guards/has-associated-store.guard';
import { IsNotUserStoreGuard } from './guards/is-not-user-store.guard';
import { TermsAndConditionsGuard } from './guards/terms-and-conditions.guard';
import { EternalPageComponent } from '../components/eternal-page/eternal-page.component';

export const routes: Routes = [
  {
    path: Route.LandingPage,
    component: LandingPageComponent,
    pathMatch: 'full'
  },
  {
    path: Route.Main,
    component: MainComponent,
    resolve: {
      roleResolverData: RoleResolver,
      ruleResolverData: RulesResolver
    },
    canActivate: [
      MsalGuard,
      HasAssociatedStoreGuard
    ],
    canActivateChild: [
      TermsAndConditionsGuard,
      HasAssociatedStoreGuard
    ],
    children: [
      {
        path: Route.HomePage,
        component: HomePageComponent,
      },
      {
        path: Route.RulePage,
        component: RulePageComponent,
        children: [
          {
            path: ``,
            component: CategoriesPageComponent
          },
          {
            path: `:${UrlParams.Rule}`,
            component: RuleComponent,
          },
          {
            path: `:${UrlParams.Rule}/:${UrlParams.Category}`,
            children: [
              {
                path: ``,
                component: ProductsPageComponent,
                providers: [FiltersService]
              },
              {
                path: Route.AddOn,
                component: EternalPageComponent
              },
            ]
          },
        ]
      },
      {
        path: Route.Product,
        children: [
          {
            path: `:${UrlParams.SapCode}`,
            component: ProductPageComponent,
            providers: [PdpService]
          }
        ]
      },
      {
        path: Route.MyBulgari,
        component: MyBulgariPageComponent,
        canActivate: [
          IsNotUserStoreGuard
        ]
      },
      {
        path: Route.PrivacyPolicy,
        component: PrivacyPolicyPageComponent
      },
      {
        path: Route.TermsAndConditions,
        component: TermsAndConditionsPageComponent
      },
      {
        path: Route.Search,
        component: SearchPageComponent
      },

    ]
  },
  {
    path: `${Route.PdfPage}`,
    component: PdfPageComponent
  },
  {
    path: Route.SetStorePage,
    component: SetStorePageComponent,
    canActivate: [
      MsalGuard,
      IsNotUserStoreGuard
    ],
  },
  {
    //path: Route.ErrorPage,
    path: "**",
    component: ErrorPageComponent
  }
];
